import request from '@/utils/request'

export function toQrBondFeePay(shopId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.toQrBondFeePay',
      method: 'post',
      data: { shopId }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}
